
import { Component, Vue } from 'vue-property-decorator'
import container from '@/components/moyo/container.vue'
import heading from '@/components/moyo/heading.vue'
import Team from '@/components/Team.vue'

@Component({
  name: 'About',
  components: { container, heading, Team },
})
export default class About extends Vue {}
